export enum StrategyQueryFetch {
  HIT,
  ALL,
}

export namespace StrategyQueryFetch {
  let elements = [StrategyQueryFetch.HIT, StrategyQueryFetch.ALL];
  let alias = "com.bcdfx.api.servicerequest.reporting.StrategyQueryFetch";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
